/* Store Generic – theme scripts (no dependencies) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var K = window.kit || { routes: { root: '/' }, strings: {} };

  function money(cents) {
    var fmt = K.moneyFormat || '${{amount}}';
    cents = parseInt(cents, 10) || 0;
    function sep(n, d, t, dec) {
      var parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return sep(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return sep(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return sep(cents, 2, "'", '.');
        default: return sep(cents, 2, ',', '.');
      }
    });
  }
  window.kitMoney = money;

  function toast(msg) {
    var t = $('#KitToast');
    if (!t) { t = document.createElement('div'); t.id = 'KitToast'; t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
  }
  function closeDrawer(d) {
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-open-drawer')); return; }
    var closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.drawer.is-open').forEach(closeDrawer);
      $$('.account-dropdown.is-open, .predictive.is-open').forEach(function (x) { x.classList.remove('is-open'); });
      $$('.popup.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    }
  });

  /* ---------- Account dropdown ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-account-toggle]');
    var dd = $('.account-dropdown');
    if (btn && dd) { e.preventDefault(); dd.classList.toggle('is-open'); return; }
    if (dd && dd.classList.contains('is-open') && !e.target.closest('.account-dropdown')) dd.classList.remove('is-open');
  });
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-account-view]');
    if (!sw) return;
    e.preventDefault();
    var wrap = sw.closest('.account-dropdown');
    $$('[data-view]', wrap).forEach(function (v) { v.hidden = v.getAttribute('data-view') !== sw.getAttribute('data-account-view'); });
  });

  /* ---------- Mobile search toggle ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-search-toggle]');
    if (!b) return;
    var s = $('.header__search'); if (!s) return;
    s.classList.toggle('is-open');
    if (s.classList.contains('is-open')) { var i = $('input', s); if (i) i.focus(); }
  });

  /* ---------- Predictive search ---------- */
  $$('[data-predictive]').forEach(function (form) {
    var input = $('input[name="q"]', form), box = $('.predictive', form), timer;
    if (!input || !box || !K.routes.predictive) return;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { box.classList.remove('is-open'); box.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(K.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { box.innerHTML = '<div class="predictive__item"><span>No results for "' + q.replace(/</g, '') + '"</span></div>'; box.classList.add('is-open'); return; }
            box.innerHTML = items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '';
              return '<a class="predictive__item" href="' + p.url + '">' + img + '<span>' + p.title + '<small>' + money(parseFloat(p.price) * 100) + '</small></span></a>';
            }).join('') + '<a class="predictive__item" href="' + K.routes.search + '?q=' + encodeURIComponent(q) + '"><span style="color:var(--brand)">View all results →</span></a>';
            box.classList.add('is-open');
          }).catch(function () {});
      }, 250);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.classList.remove('is-open'); });
  });

  /* ---------- Slideshow ---------- */
  $$('[data-slideshow]').forEach(function (el) {
    var track = $('.slideshow__track', el), slides = $$('.slide', el), dots = $$('.slideshow__dots button', el), i = 0, timer;
    if (slides.length < 2) return;
    var speed = parseInt(el.getAttribute('data-speed'), 10) || 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function auto() { if (speed) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed * 1000); } }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); auto(); }); });
    var p = $('.slideshow__arrow--prev', el), n = $('.slideshow__arrow--next', el);
    if (p) p.addEventListener('click', function () { go(i - 1); auto(); });
    if (n) n.addEventListener('click', function () { go(i + 1); auto(); });
    var sx = 0;
    el.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); auto(); } });
    auto();
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window && document.body.classList.contains('has-reveal')) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -60px 0px' });
    $$('.reveal').forEach(function (r) { io.observe(r); });
  } else { $$('.reveal').forEach(function (r) { r.classList.add('is-in'); }); }

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input'); if (!input) return;
    var v = parseInt(input.value, 10) || 0, min = parseInt(input.min, 10) || 0;
    v = b.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(min, v - 1);
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart (AJAX) ---------- */
  function fetchSections() {
    return fetch(K.routes.root.replace(/\/$/, '') + '/?sections=kit-cart-drawer-content').then(function (r) { return r.json(); });
  }
  function refreshCart(open) {
    return fetchSections().then(function (d) {
      var html = d['kit-cart-drawer-content'];
      if (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var nb = $('[data-cart-inner]', tmp), cur = $('[data-cart-inner]');
        if (nb && cur) cur.innerHTML = nb.innerHTML;
        var count = nb ? nb.getAttribute('data-count') : null;
        if (count !== null) $$('[data-cart-count]').forEach(function (c) { c.textContent = count; });
      }
      if (open) openDrawer('CartDrawer');
    });
  }
  window.kitRefreshCart = refreshCart;

  function addToCart(form, btn) {
    var fd = new FormData(form);
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = K.strings.adding || 'Adding...'; }
    return fetch(K.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || 'Error'); return; }
        if (K.cartType === 'page') { window.location.href = K.routes.cart; return; }
        return refreshCart(true);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  function changeLine(line, qty) {
    return fetch(K.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshCart(false);
      });
  }
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line-qty]');
    if (i) changeLine(parseInt(i.getAttribute('data-line-qty'), 10), parseInt(i.value, 10) || 0);
  });
  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-line-remove]');
    if (r) { e.preventDefault(); changeLine(parseInt(r.getAttribute('data-line-remove'), 10), 0); }
    var c = e.target.closest('[data-cart-open]');
    if (c && K.cartType !== 'page') { e.preventDefault(); openDrawer('CartDrawer'); }
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(function (root) {
    var json = $('[data-product-json]', root); if (!json) return;
    var product = JSON.parse(json.textContent);
    var form = $('form[data-ajax-cart]', root) || $('form[action*="/cart/add"]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root), saveEl = $('[data-save]', root);
    var atc = $('[data-atc]', root), atcLabel = atc ? $('span', atc) : null;
    var stickyPrice = $('[data-sticky-price]');
    var saveLabel = root.getAttribute('data-save-label') || 'Save';

    function currentOptions() {
      return $$('[data-option-index]', root).map(function (fs) {
        var c = $('input:checked', fs) || $('select', fs);
        return c ? c.value : null;
      });
    }
    function update() {
      var opts = currentOptions();
      var v = product.variants.find(function (x) { return x.options.every(function (o, k) { return o === opts[k]; }); });
      $$('[data-option-index]', root).forEach(function (fs) {
        var lbl = $('[data-selected-value]', fs), c = $('input:checked', fs);
        if (lbl && c) lbl.textContent = c.value;
      });
      if (!v) {
        if (atc) { atc.disabled = true; if (atcLabel) atcLabel.textContent = K.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.textContent = onSale ? money(v.compare_at_price) : ''; compareEl.hidden = !onSale; }
      if (saveEl) { saveEl.textContent = onSale ? saveLabel + ' ' + money(v.compare_at_price - v.price) : ''; saveEl.hidden = !onSale; }
      if (atc) { atc.disabled = !v.available; if (atcLabel) atcLabel.textContent = v.available ? K.strings.addToCart : K.strings.soldOut; }
      if (v.featured_media) {
        var t = $('[data-media-id="' + v.featured_media.id + '"]', root);
        if (t) t.click();
      }
      if (history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) update(); });

    // gallery
    var slides = $$('.gallery__slide', root), thumbs = $$('.gallery__thumbs button', root), gi = 0;
    function show(n) {
      if (!slides.length) return;
      gi = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === gi); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === gi); });
      var main = $('.gallery__main', root); if (main) main.classList.remove('is-zoomed');
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var gp = $('.gallery__nav--prev', root), gn = $('.gallery__nav--next', root);
    if (gp) gp.addEventListener('click', function (e) { e.stopPropagation(); show(gi - 1); });
    if (gn) gn.addEventListener('click', function (e) { e.stopPropagation(); show(gi + 1); });
    var main = $('.gallery__main', root);
    if (main) {
      main.addEventListener('click', function () { main.classList.toggle('is-zoomed'); });
      main.addEventListener('mousemove', function (e) {
        if (!main.classList.contains('is-zoomed')) return;
        var r = main.getBoundingClientRect(), img = $('.gallery__slide.is-active img', main);
        if (img) img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      var tsx = 0;
      main.addEventListener('touchstart', function (e) { tsx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - tsx; if (Math.abs(dx) > 40) show(dx < 0 ? gi + 1 : gi - 1); });
    }

    // sticky add to cart
    var sticky = $('.sticky-atc');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(atc);
      var sb = $('[data-sticky-atc]', sticky);
      if (sb && form) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }

    // recently viewed
    try {
      var key = 'kit_recent', list = JSON.parse(localStorage.getItem(key) || '[]');
      list = list.filter(function (h) { return h !== product.handle; }); list.unshift(product.handle);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (err) {}
  });

  /* ---------- Recently viewed ---------- */
  $$('[data-recently-viewed]').forEach(function (wrap) {
    var list = [];
    try { list = JSON.parse(localStorage.getItem('kit_recent') || '[]'); } catch (e) {}
    var current = wrap.getAttribute('data-current');
    list = list.filter(function (h) { return h && h !== current; }).slice(0, parseInt(wrap.getAttribute('data-limit'), 10) || 4);
    if (!list.length) return;
    var grid = $('.product-grid', wrap);
    Promise.all(list.map(function (h) {
      return fetch(K.routes.root.replace(/\/$/, '') + '/products/' + h + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (cards) {
      var html = cards.filter(Boolean).map(function (c) { return '<li>' + c + '</li>'; }).join('');
      if (html) { grid.innerHTML = html; wrap.hidden = false; }
    });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (wrap) {
    var url = wrap.getAttribute('data-url'); if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (t) {
      var tmp = document.createElement('div'); tmp.innerHTML = t;
      var inner = tmp.querySelector('[data-recommendations]');
      if (inner && inner.querySelector('.card')) { wrap.innerHTML = inner.innerHTML; wrap.hidden = false; }
    }).catch(function () {});
  });

  /* ---------- Collection: view toggle + sort + per page ---------- */
  $$('[data-view-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grid = $('[data-collection-grid]'); if (!grid) return;
      var v = btn.getAttribute('data-view-toggle');
      grid.classList.toggle('product-grid--list', v === 'list');
      $$('[data-view-toggle]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      try { localStorage.setItem('kit_view', v); } catch (e) {}
    });
  });
  try { var sv = localStorage.getItem('kit_view'); if (sv === 'list') { var lb = $('[data-view-toggle="list"]'); if (lb) lb.click(); } } catch (e) {}
  $$('[data-url-param]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set(sel.getAttribute('data-url-param'), sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  $$('[data-filter-form]').forEach(function (f) {
    f.addEventListener('change', function () { f.requestSubmit ? f.requestSubmit() : f.submit(); });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-filters-toggle]');
    if (b) { var w = $('.filters-wrap'); if (w) w.classList.toggle('is-open'); }
  });

  /* ---------- Popups ---------- */
  $$('[data-popup]').forEach(function (p) {
    var key = 'kit_popup_' + p.id, delay = (parseInt(p.getAttribute('data-delay'), 10) || 5) * 1000;
    var days = parseInt(p.getAttribute('data-days'), 10) || 3;
    var test = p.hasAttribute('data-test');
    var last = 0;
    try { last = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
    function close() { p.classList.remove('is-open'); try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
    $$('[data-popup-close]', p).forEach(function (c) { c.addEventListener('click', close); });
    if (!test && last && Date.now() - last < days * 864e5) return;
    setTimeout(function () { p.classList.add('is-open'); }, test ? 300 : delay);
  });

  /* ---------- Copy to clipboard (popup code) ---------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy]');
    if (!c) return;
    if (navigator.clipboard) navigator.clipboard.writeText(c.getAttribute('data-copy')).then(function () { toast('Copied!'); });
  });

  /* ---------- Sticky header ---------- */
  var sh = $('.site-header[data-sticky]');
  if (sh) sh.classList.add('is-sticky');

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function () { $$('.reveal').forEach(function (r) { r.classList.add('is-in'); }); });
})();
